import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class ItemOptionsFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async save() {
    const collection = this.view.getCollectionName();

    if (this.object.id) {
      this.change.id = this.object.id
    } else {
      this.change.id = this.object.id;
      this.change.acl = this.view.getAcl();
    }

    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Successfully Saved!");
      this.change = {};
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default ItemOptionsFormPresenter;
